/**
 * Generated by orval v6.30.2 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
export type PersistVoiceMessagesVoiceConversationPostParams = {
chat_model_id?: ChatbotKey | null;
};

export type GenerateResponseVoiceGeneratePostParams = {
chat_model_id?: ChatbotKey | null;
api_key?: string | null;
};

export type GenerateResponseConversationPostParams = {
chat_model_id?: ChatbotKey | null;
api_key?: string | null;
};

export type ConversationMessagesConversationMessagesGetParams = {
/**
 * Maximum number of records to return
 */
amount?: number;
/**
 * Get records before this date
 */
before?: string | null;
chat_model_id?: ChatbotKey | null;
};

export type VoiceConversationInputMessage = ChatTextMessageInput | InitiateVoiceCommandMessage;

/**
 * The data passed as part of a request to the /voice/generate endpoint
 */
export interface VoiceConversationInput {
  message: VoiceConversationInputMessage;
  uncommitted_messages?: MessageInput[];
}

export type ValidationErrorLocItem = string | number;

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}

/**
 * The transcript of the speech response
 */
export interface TranscriptResponse {
  transcript: MessageOutput[];
  type?: string;
}

/**
 * "tool
 */
export interface ToolCall {
  function: Function;
  id: string;
  type: string;
}

/**
 * The response from the /voice/generate endpoint
 */
export interface SpeechResponse {
  id: string;
  type?: string;
  value: string;
}

export type GenerateResponseVoiceGeneratePost200 = SpeechResponse | TranscriptResponse;

/**
 * The data passed as part of the request to the /voice/conversation endpoint
 */
export interface PersistVoiceMessagesInput {
  messages?: MessageInput[];
}

/**
 * Onboarding command message to be sent by client to trigger onboarding flow
 */
export interface OnboardingCommandMessage {
  subtype?: string;
  type?: string;
  type_discriminator?: string;
}

export type MessageType = typeof MessageType[keyof typeof MessageType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageType = {
  text: 'text',
  options: 'options',
  voice: 'voice',
} as const;

export type MessageOrigin = typeof MessageOrigin[keyof typeof MessageOrigin];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageOrigin = {
  user_typed: 'user_typed',
  user_home_screen_card: 'user_home_screen_card',
  user_conversation_starter: 'user_conversation_starter',
  user_system_command: 'user_system_command',
  user_voice: 'user_voice',
  user_voice_system_command: 'user_voice_system_command',
  assistant_generated: 'assistant_generated',
  assistant_moderation_response: 'assistant_moderation_response',
} as const;

export interface MessageMetadata { [key: string]: any }

export interface MessageContent {
  body: string;
}

export type MessageOutputToolCalls = ToolCall[] | null;

export type MessageOutputToolCallName = string | null;

export type MessageOutputToolCallId = string | null;

export type MessageOutputMetadata = MessageMetadata | null;

export type MessageOutputMessageOrigin = MessageOrigin | null;

export type MessageOutputContent = string | null;

export interface MessageOutput {
  content?: MessageOutputContent;
  created_at?: string;
  id?: string;
  is_onboarding?: boolean;
  message_origin?: MessageOutputMessageOrigin;
  message_type?: MessageType;
  metadata?: MessageOutputMetadata;
  role: ConversationRole;
  tool_call_id?: MessageOutputToolCallId;
  tool_call_name?: MessageOutputToolCallName;
  tool_calls?: MessageOutputToolCalls;
}

export type MessageInputToolCalls = ToolCall[] | null;

export type MessageInputToolCallName = string | null;

export type MessageInputToolCallId = string | null;

export type MessageInputMetadata = MessageMetadata | null;

export type MessageInputMessageOrigin = MessageOrigin | null;

export type MessageInputContent = string | null;

export interface MessageInput {
  content?: MessageInputContent;
  created_at?: string;
  id?: string;
  is_onboarding?: boolean;
  message_origin?: MessageInputMessageOrigin;
  message_type?: MessageType;
  metadata?: MessageInputMetadata;
  role: ConversationRole;
  tool_call_id?: MessageInputToolCallId;
  tool_call_name?: MessageInputToolCallName;
  tool_calls?: MessageInputToolCalls;
}

export type MappedConversationRole = typeof MappedConversationRole[keyof typeof MappedConversationRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MappedConversationRole = {
  user: 'user',
  assistant: 'assistant',
} as const;

export interface MappedConversationMessage {
  content: MessageContent;
  created_at: string;
  id: string;
  role: MappedConversationRole;
}

/**
 * Initiate voice command message to be sent by client to trigger voice flow
 */
export interface InitiateVoiceCommandMessage {
  subtype?: string;
  type?: string;
  type_discriminator?: string;
}

export interface HTTPValidationError {
  detail?: ValidationError[];
}

export interface Function {
  arguments: string;
  name: string;
}

/**
 * Follow up command message to be sent by client
 */
export interface FollowUpCommandMessage {
  subtype?: string;
  type?: string;
  type_discriminator?: string;
}

/**
 * The response from the /conversation endpoint
 */
export interface ConversationStreamingResponse {
  content: ChatTextMessageOutput;
  id: string;
  sequence_id: number;
  triggered_by_user_message_id: string;
}

export type ConversationStarterTopic = typeof ConversationStarterTopic[keyof typeof ConversationStarterTopic];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationStarterTopic = {
  self_reflection: 'self_reflection',
  goal_setting: 'goal_setting',
  work_support: 'work_support',
  stress_and_coping: 'stress_and_coping',
  motivation: 'motivation',
  focus_and_productivity: 'focus_and_productivity',
  wellbeing_resources: 'wellbeing_resources',
} as const;

export type ConversationStarterMessageValue = string | null;

export type ConversationStarterMessageSubtype = string | null;

/**
 * A conversation starter message to be sent by user
 */
export interface ConversationStarterMessage {
  starter_id: string;
  subtype?: ConversationStarterMessageSubtype;
  type?: string;
  type_discriminator?: string;
  value: ConversationStarterMessageValue;
}

export interface ConversationStarter {
  emoji: string;
  id: string;
  text: string;
  topic: typeof ConversationStarterTopicProperty[keyof typeof ConversationStarterTopicProperty] ;
}

export type ConversationRole = typeof ConversationRole[keyof typeof ConversationRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationRole = {
  user: 'user',
  assistant: 'assistant',
  system: 'system',
  tool: 'tool',
} as const;

export type ConversationMessagePaginationStartCursor = string | null;

export type ConversationMessagePaginationEndCursor = string | null;

export type ConversationMessagePaginationConversationId = string | null;

export interface ConversationMessagePagination {
  conversation_id?: ConversationMessagePaginationConversationId;
  endCursor?: ConversationMessagePaginationEndCursor;
  hasNext: boolean;
  hasPrevious: boolean;
  items: MappedConversationMessage[];
  startCursor?: ConversationMessagePaginationStartCursor;
}

export type ConversationManagerStarterTopic = typeof ConversationManagerStarterTopic[keyof typeof ConversationManagerStarterTopic];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationManagerStarterTopic = {
  team_leadership: 'team_leadership',
  difficult_conversations: 'difficult_conversations',
  change_and_strategy: 'change_and_strategy',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationStarterTopicProperty = {...ConversationStarterTopic,...ConversationManagerStarterTopic,} as const;

export type ConversationInputMessage = ChatTextMessageInput | FollowUpCommandMessage | OnboardingCommandMessage | AdviceCardMessage | ConversationStarterMessage;

/**
 * The data passed as part of a request to the /conversation endpoint
 */
export interface ConversationInput {
  message: ConversationInputMessage;
  metadata: ClientMetadata;
}

export type ClientMetadataClientSentAtUtcTimestamp = string | null;

export interface ClientMetadata {
  clientSentAtUtcTimestamp?: ClientMetadataClientSentAtUtcTimestamp;
}

export type ChatbotKey = typeof ChatbotKey[keyof typeof ChatbotKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatbotKey = {
  default: 'default',
  onboarding: 'onboarding',
  voice: 'voice',
} as const;

export type ChatTextMessageOutputValue = string | null;

export type ChatTextMessageOutputSubtype = string | null;

/**
 * A text based message to be sent by user
 */
export interface ChatTextMessageOutput {
  subtype?: ChatTextMessageOutputSubtype;
  type?: string;
  value: ChatTextMessageOutputValue;
}

export type ChatTextMessageInputValue = string | null;

export type ChatTextMessageInputSubtype = string | null;

/**
 * A text based message to be sent by user
 */
export interface ChatTextMessageInput {
  subtype?: ChatTextMessageInputSubtype;
  type?: string;
  type_discriminator?: string;
  value: ChatTextMessageInputValue;
}

export type AdviceCardType = typeof AdviceCardType[keyof typeof AdviceCardType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdviceCardType = {
  exploration: 'exploration',
  action: 'action',
  resource: 'resource',
} as const;

export type AdviceCardMessageValue = string | null;

export type AdviceCardMessageSubtype = string | null;

/**
 * An Advice Card message to be sent by user
 */
export interface AdviceCardMessage {
  advice_card_id: string;
  subtype?: AdviceCardMessageSubtype;
  type?: string;
  type_discriminator?: string;
  value: AdviceCardMessageValue;
}

/**
 * Advice cards to be sent by client
 */
export interface AdviceCard {
  id: string;
  image_url: string;
  theme: string;
  type: AdviceCardType;
  value: string;
}

